import { Layout, Menu } from 'antd';
import { MailOutlined, SettingOutlined, AppstoreOutlined, UserOutlined, GroupOutlined } from '@ant-design/icons';
import './index.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
const { Sider } = Layout;


const iconList = {
  '/home': <UserOutlined />,
  '/user-manage': <UserOutlined />,
  '/user-manage/list': <UserOutlined />,
  '/right-manage': <UserOutlined />,
  '/right-manage/group/list': <UserOutlined />,
  '/announcement': <GroupOutlined />,
  '/announcement/list': <GroupOutlined />,
}

const filterList = [
  '/profile'
]

function SideMenu(props) {
  const [menu, setMenu] = useState([])
  const checkPermission = (item) => (
    item.page_permission === 1 && props.groupPermission.permissions.includes(item.key) && !filterList.includes(item.key)
  )
  const isChildsHasPagePermission = (routes)=> {
    if(typeof routes === 'object' && routes.length > 0){
      return routes.filter(route=>route.page_permission === 1).length > 0
    }
    return false
  }
  //過濾權限，加入icon
  const renderMenu = (menu)=>{
    return menu.filter(item=>{
      if(checkPermission(item)){
        //加入圖標
        if(item.key in iconList){
          item.icon = iconList[item.key]
        }
        //確認是否有children，有的話才進行length長度的判斷
        if(isChildsHasPagePermission(item.children)){
          item.children = renderMenu(item.children);
        }else{
          delete item.children
        }
        return item
      }
      return false
    })
  }

  useEffect(()=>{
    axios.get('/api/page-route').then(res=>{
      setMenu(renderMenu(res.data))
    }).catch(err=>{
      console.error(err)
    })
  },[])

  const selectKeys = [props.location.pathname]
  const openKeys = ["/" + props.location.pathname.split('/')[1]]
  return (
    <Sider trigger={null} collapsible collapsed={props.isCollapsed} collapsedWidth={0}>
      <div style={{ display:'flex', height:'100%', 'flexDirection':'column' }}>
        <div className="logo">翰可能源預約系統</div>
        <div style={{ flex:1, overflow:'auto' }}>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={selectKeys}
            defaultOpenKeys={openKeys}
            items={menu}
            onClick={({key})=>{
              props.history.push(key)
            }}
          />
        </div>
      </div>
      </Sider>
  )
}
const mapStateToProps = ({
  collapsedReducer:{isCollapsed},
  userProfileReducer: {groupPermission}
}) => ({
  isCollapsed,
  groupPermission
})

export default connect(mapStateToProps)(withRouter(SideMenu))
